import React from 'react';
import { Scale, FileCheck, AlertTriangle, CreditCard, Briefcase, Globe } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="pt-32 pb-16 bg-[#061225] min-h-screen text-gray-300 font-sans">
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Terms of <span className="text-[#0EA5E9]">Service</span></h1>
          {/* <p className="text-gray-400">Last updated: {new Date().toLocaleDateString()}</p> */}
        </div>

        <div className="space-y-8 bg-[#0F1629] p-8 md:p-10 rounded-2xl border border-white/5 shadow-2xl">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
              <Scale className="w-6 h-6 text-[#0EA5E9]" />
              1. Acceptance of Terms
            </h2>
            <p className="leading-relaxed text-gray-400">
              By accessing and using the services provided by VishwaDigitech, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to abide by these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
              <Briefcase className="w-6 h-6 text-emerald-400" />
              2. Description of Services
            </h2>
            <p className="leading-relaxed text-gray-400 mb-4">
              VishwaDigitech provides various IT and digital marketing services, including but not limited to:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-400">
              <li>Website and Application Development</li>
              <li>Custom Software Solutions</li>
              <li>Search Engine Optimization (SEO) & Search Engine Marketing (SEM)</li>
              <li>Social Media Marketing and Management</li>
              <li>Graphics Design and Video Production</li>
              <li>WhatsApp API Integration</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
              <FileCheck className="w-6 h-6 text-violet-500" />
              3. Client Obligations
            </h2>
            <p className="leading-relaxed text-gray-400">
              The client agrees to provide all necessary information, resources, and approvals required for VishwaDigitech to perform the agreed-upon services. Any delays in providing such resources may result in project delays for which VishwaDigitech cannot be held responsible.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
              <CreditCard className="w-6 h-6 text-[#0EA5E9]" />
              4. Payment Terms
            </h2>
            <p className="leading-relaxed text-gray-400 mb-4">
              Our payment terms vary by project and will be explicitly stated in the proposal or contract. Generally:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-400">
              <li>An upfront deposit is required before the commencement of any project.</li>
              <li>Subsequent payments are tied to predefined project milestones.</li>
              <li>Final payment is due upon project completion or before final deployment/handover.</li>
              <li>All payments are non-refundable unless otherwise stated in writing.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
              <AlertTriangle className="w-6 h-6 text-emerald-400" />
              5. Intellectual Property
            </h2>
            <p className="leading-relaxed text-gray-400">
              Upon full payment, the client will retain ownership of the final deliverables (e.g., website code, graphics). However, VishwaDigitech reserves the right to use the completed project in our portfolio, marketing materials, and case studies unless a Non-Disclosure Agreement (NDA) is signed prior to the project's start.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
              <AlertTriangle className="w-6 h-6 text-violet-500" />
              6. Limitation of Liability
            </h2>
            <p className="leading-relaxed text-gray-400">
              VishwaDigitech shall not be liable for any indirect, incidental, special, or consequential damages, including loss of profits, revenue, data, or use, incurred by the client or any third party, whether in an action in contract or tort, arising from your access to, or use of, our services.
            </p>
          </section>

          <section className="pt-4 border-t border-white/10">
            <h2 className="text-2xl font-bold text-white mb-4">7. Contact Us</h2>
            <p className="leading-relaxed text-gray-400">
              If you have any questions regarding these Terms of Service, please contact us at:
            </p>
            <div className="mt-4 bg-white/5 p-4 rounded-xl inline-block border border-white/10">
              <p className="text-white font-medium">VishwaDigitech</p>
              <p className="text-gray-400 mt-1 flex items-center gap-2"><Globe className="w-4 h-4 text-gray-500"/> Website: <a href="https://vishwadigitech.com" className="text-gray-400 hover:text-white transition-colors">vishwadigitech.com</a></p>
              <p className="text-gray-400 mt-1 flex items-center gap-2">Email: <a href="mailto:info@vishwadigitech.com" className="text-[#0EA5E9] hover:underline">info@vishwadigitech.com</a></p>
              <p className="text-gray-400 mt-1 flex items-center gap-2">Phone: <a href="tel:+919699938509" className="text-emerald-400 hover:underline">+91 9699938509</a></p>
              <p className="text-gray-400 mt-2 text-sm">Address: 2nd floor, V S Khandekar Vachanalay, Sangli, Khanbhag, Sangli Miraj Kupwad, Maharashtra 416416</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
